"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributesFacetNav = void 0;
const react_1 = __importStar(require("react"));
const ramda_1 = require("ramda");
const react_redux_1 = require("react-redux");
const attributes_utils_1 = require("../attributes.utils");
const tree_navigation_1 = require("../../tree-navigation");
const formal_attributes_1 = require("../../../formal-attributes");
const store_1 = require("../../../../store");
const utils_1 = require("../../../../utils");
const AttributesFacetNav = ({ expandOverride, debouncedSearchTerm, }) => {
    const { actualAttributes } = (0, store_1.useRefinementsDataSelector)();
    const includedAttributesIds = (0, store_1.useProductsIncludedAttributesIds)();
    const excludedAttributesIds = (0, store_1.useProductsExcludedAttributesIds)();
    const { getAttributeName, getAttributeValueName, } = (0, formal_attributes_1.useFormalAttributes)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const [facetNavData, setFacetNavData] = (0, react_1.useState)(new Map());
    const changeAttributesIds = (0, react_1.useCallback)((selectedId, prevAttributesIds) => {
        const selectedAttributesIds = [selectedId];
        return (0, ramda_1.all)((selectedAttributeId) => prevAttributesIds.includes(selectedAttributeId), selectedAttributesIds)
            ? (0, ramda_1.without)(selectedAttributesIds, prevAttributesIds)
            : (0, ramda_1.uniq)((0, ramda_1.concat)(selectedAttributesIds, prevAttributesIds));
    }, []);
    const handleSetInclude = (0, react_1.useCallback)((selectedId) => {
        const includedAttributeIds = changeAttributesIds(selectedId, includedAttributesIds);
        dispatch((0, store_1.productsSetIncludedAttributesIds)(includedAttributeIds));
    }, [dispatch, includedAttributesIds, changeAttributesIds]);
    const handleSetExclude = (0, react_1.useCallback)((selectedId) => {
        const excludedAttributeIds = changeAttributesIds(selectedId, excludedAttributesIds);
        dispatch((0, store_1.productsSetExcludedAttributesIds)(excludedAttributeIds));
    }, [dispatch, excludedAttributesIds, changeAttributesIds]);
    const getActualAttributesMap = (0, react_1.useCallback)(() => {
        const attributeMap = actualAttributes.reduce((map, actualAttribute) => {
            var _a, _b;
            const valueTitle = (0, attributes_utils_1.getAttributeValueTitle)({ subAttribute: actualAttribute, getAttributeName, getAttributeValueName });
            if (!valueTitle)
                return map;
            const valueId = [actualAttribute.attributeId, (_a = actualAttribute.valueId) !== null && _a !== void 0 ? _a : '', (_b = actualAttribute.valueName) !== null && _b !== void 0 ? _b : ''].join(store_1.ATTRIBUTE_PROPERTY_DELIMITER);
            const attributeValue = Object.assign(Object.assign({}, actualAttribute), { children: new Map(), title: valueTitle, parentId: actualAttribute.attributeId, id: valueId });
            if (!map.has(actualAttribute.attributeId)) {
                map.set(actualAttribute.attributeId, Object.assign(Object.assign({}, actualAttribute), { title: getAttributeName(actualAttribute.attributeId), children: new Map([[valueId, attributeValue]]), parentId: null, id: actualAttribute.attributeId }));
            }
            else {
                const attribute = map.get(actualAttribute.attributeId);
                attribute.children.set(valueId, attributeValue);
            }
            return map;
        }, new Map());
        // order attribute values alphabetically
        attributeMap.forEach((attribute) => {
            if (attribute.children && attribute.children.size > 1) {
                attribute.children = new Map([...attribute.children.entries()].sort((a, b) => (a[1].title > b[1].title ? 1 : -1)));
            }
        });
        return attributeMap;
    }, [getAttributeName, actualAttributes, getAttributeValueName]);
    const parentIds = (0, react_1.useMemo)(() => (0, utils_1.getNodesWithChildren)(facetNavData), [facetNavData]);
    (0, react_1.useEffect)(() => {
        if (actualAttributes.length) {
            const attributesMap = getActualAttributesMap();
            setFacetNavData(attributesMap);
        }
    }, [actualAttributes, getActualAttributesMap]);
    return (react_1.default.createElement(tree_navigation_1.TreeNavigation, { included: includedAttributesIds, excluded: excludedAttributesIds, debouncedSearchTerm: debouncedSearchTerm, setExcluded: handleSetExclude, setIncluded: handleSetInclude, treeData: facetNavData, parentIds: parentIds, expandOverride: expandOverride }));
};
exports.AttributesFacetNav = AttributesFacetNav;
exports.default = exports.AttributesFacetNav;
